// Set a data attribute on <html>
const setHtmlAttr = (name: string, value: string) => {
    document.documentElement.setAttribute(name, value);
};

export default defineNuxtPlugin((nuxtApp) => {
    // Triggered once, when the Nuxt app has fully mounted and hydration is done
    nuxtApp.hook('app:mounted', () => {
        setHtmlAttr('data-nuxt-hydrated', 'true');
    });

    // Triggered after route navigation when the page rendering has finished
    nuxtApp.hook('page:finish', () => {
        setHtmlAttr('data-nuxt-page-ready', 'true');
    });
});
